import React from 'react';

import Form from '../../Shared/UI/Form/components/Form';
import Field from '../../Shared/UI/Field/components/Field';
import Select from '../../Shared/UI/Select/components/Select';
import FormActions from '../../Shared/UI/FormActions/components/FormActions';
import Button from '../../Shared/UI/Button/components/Button';
import ResponsiveContainer from '../../Shared/UI/ResponsiveContainer/components/ResponsiveContainer';

import { useTagState, useTagActions } from './TagContext';

import { denyTaggingRule } from './restApi';

const NewDeniedTaggingRuleForm = () => {
  const state = useTagState();
  const {
    onResponse,
    onError,
    updateSelectedTagTypeOnNewDeniedTaggingRule,
    updateSelectedTaggableTypeOnNewDeniedTaggingRule,
  } = useTagActions();
  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  const handleSubmit = () => {
    denyTaggingRule({
      onResponse,
      onError,
      body: {
        authenticityToken,
        tagId: state?.newDeniedTaggingRuleForm?.tagId,
        tagType: state?.newDeniedTaggingRuleForm?.tagType,
        taggableType: state?.newDeniedTaggingRuleForm?.taggableType,
      },
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Field label="Tag Type" id="tagType">
        <Select
          value={state?.newDeniedTaggingRuleForm?.tagType || ''}
          onChange={(e) => updateSelectedTagTypeOnNewDeniedTaggingRule(e.target.value)}
        >
          {(state?.tagTypeOptions || []).map((option) => (
            <option key={option.value} value={option.value}>{option.displayValue}</option>
          ))}
        </Select>
      </Field>

      <Field label="Taggable Type" id="taggableType">
        <Select
          value={state?.newDeniedTaggingRuleForm?.taggableType || ''}
          onChange={(e) => updateSelectedTaggableTypeOnNewDeniedTaggingRule(e.target.value)}
        >
          {(state?.taggableTypeOptions || []).map((option) => (
            <option key={option.value} value={option.value}>{option.displayValue}</option>
          ))}
        </Select>
      </Field>

      <ResponsiveContainer name="form-actions">
        <FormActions>
          <Button type="submit">Deny Tagging Rule</Button>
        </FormActions>
      </ResponsiveContainer>
    </Form>
  );
};

export default NewDeniedTaggingRuleForm;
